<div class="rss-container" *ngIf="!containsError">
  <div>
     <span class="pageHeader" id="rssTransactionsHeader">
       RSS Transactions
			</span>
  </div>
  <br><br><br>
  <div *ngIf="displayMess">
    <div class="successMessAlign">
      <p>
        {{rssSuccMess}}
      </p>
    </div>
  </div>
  <div *ngIf="displyRssTbl && !displayMess">
    <form [formGroup]="searchForm" (ngSubmit)="saveBtn()">
      <span class="adminTblAlign">
            <div class="ui-g-3 lblAlign"> Transaction Type:  </div>
            <div class="ui-g-3">   <fm-select
              [options]="transType"
              [(ngModel)]="selectedType"
              ariaLabelledBy="default"
            ></fm-select></div>
          </span>
        <span class="adminTblAlign">
            <span class="ui-g-3 lblAlign"> FannieMae Loan Number:	 </span>
            <div class="ui-g-3"> <input type="text" maxlength="10" formControlName='lnNumber' fmTextInput (keypress)="this.utilService.numberOnly($event)">  </div>
          </span>
        <span class="adminTblAlign">
             <div class="ui-g-3 lblAlign"> Seller Number:	 </div>
             <div class="ui-g-3"> <input type="text" maxlength="9" formControlName='selNumber' fmTextInput (keypress)="this.utilService.numberOnly($event)"></div>
          </span>
        <span class="adminTblAlign">
             <div class="ui-g-3 lblAlign"> Amount: </div>
             <div class="ui-g-3"> <input type="text" formControlName='lnAmount' fmTextInput (keypress)="this.utilService.numberOnly($event)"></div>
         </span>
        <div class="btnAlign">
          <button fmButton type="submit" [small]="true" [primary]="true" label="Save"
                  class="dispbuttonMargin"></button>
          <button fmButton type="button" [small]="true" label="Clear" (click)="clearBtn()"
                  class="dispbuttonMargin"></button>
          <button fmButton type="button" routerLink="/admin" [small]="true" label="Cancel"
                  class="dispbuttonMargin"></button>
        </div>
    </form>
  </div>
</div>
<br>
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>
